import * as MobX from "mobx";
import { Stores } from "../Stores";
import { BaseStore, KeyValuePair } from "@shoothill/core";
import { InitialState } from "Globals/Models";
import { Religion } from "Globals/Models/Religion";

export class ReligionStore extends BaseStore {
    public constructor() {
        super();
    }
    @MobX.observable private religion: Religion[] = [];
    public async init(stores: Stores, initialState: InitialState) {
        this.religion = initialState.religions;
    }

    @MobX.action
    public getReligionName(religionId: string | null): string {
        if (religionId == "0" || religionId == null || religionId == "") return "Error";
        let value = this.getSortedByOrdinal.find((value) => religionId === value.id);
        return value ? value.name : "Unknown";
    }

    @MobX.computed
    public get getSortedByOrdinal(): Religion[] {
        return this.religion.slice().sort((a, b) => (a.ordinal < b.ordinal ? -1 : 1));
    }

    @MobX.computed
    public get getReligionOptions(): KeyValuePair[] {
        let placeholder = {
            key: "Please select",
            value: "placeholder",
        } as KeyValuePair;

        let options = this.getSortedByOrdinal.map((value) => ({ value: value.id, key: value.name })) as KeyValuePair[];

        options.unshift(placeholder);

        return options;
    }
}
